import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {},
  dates: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  startDateButton: {
    marginRight: theme.spacing(1)
  },
  endDateButton: {
    marginLeft: theme.spacing(1)
  },
  calendarTodayIcon: {
    marginRight: theme.spacing(1)
  }
}));

function Header({ className, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation('today_summary');
  const SessionUser = getUser();
  const data = {
    name: `${SessionUser.FirstName} ${SessionUser.LastName}`
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography
        component="h2"
        gutterBottom
        variant="overline"
      />
      <Typography
        component="h1"
        gutterBottom
        variant="h3"
      >
        {t('Merhaba')}
        ,
        {' '}
        {data.name}
      </Typography>
      <Typography variant="subtitle1">
        {t('Header_subtext')}
      </Typography>
    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
